import React, {useEffect, useRef, useState} from "react";
import {FlexItem, FlexLayout, Link, Spinner, StackLayout, Text} from "@salt-ds/core";
import { useLocation } from 'react-router';

import "./indePageComponent.css"
import CardAlert from "../../components/common/card-alert/CardAlert";

import Constants from "../../components/common/Constants";
import IndexPageFormComponent from "./IndexPageForm/IndexPageFormComponent";
import {TargetRedirectComponent} from "../TargetRedirect/TargetRedirectComponent.tsx";
import {useIntl} from 'react-intl';

function StatusDisplay({
    isSmallScreen,
    hasError,
    showRedirect,
    isLoading,
    sessionExpired,
    errorMessage,
    setHasError
}) {
    if (showRedirect) {
        return (
            <FlexItem className="spinner-wrapper">
                <Spinner data-testid="spinner-loading" aria-label="redirecting" role="status" size="medium" />
                <TargetRedirectComponent />
            </FlexItem>
        );
    }
    if (isLoading) {
        return (
            <FlexItem className="spinner-wrapper">
                <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" />
            </FlexItem>
        );
    }
    if (isSmallScreen && hasError) {
        return (
            <FlexItem className={`error-wrapper-index visible`}>
                <CardAlert contentStyle={{ maxWidth: "47rem" }} status={sessionExpired && hasError ? "warning" : "error"} setHasError={setHasError}>
                    {errorMessage}
                </CardAlert>
            </FlexItem>
        );
    }
    if (!isSmallScreen) {
        return (
            <FlexItem className={`error-wrapper-index ${hasError ? 'visible' : ''}`}>
                <CardAlert contentStyle={{ maxWidth: '47rem' }} status={sessionExpired && hasError ? "warning" : "error"} setHasError={setHasError}>
                    {errorMessage}
                </CardAlert>
            </FlexItem>
        );
    }
    return null;
}

export default function IndexPageComponent(props) {
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage]  = useState("One of the fields you entered is not correct or your access is not permitted at this time");
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 960);
    const location = useLocation();
    const sessionExpired = location.state?.sessionExpired;
    const [isLoading, setIsLoading] = useState(false);
    const [showRedirect, setShowRedirect] = useState(false);
    const intl = useIntl();
    const mainRef = useRef(null);

    useEffect(() => {
        // Added to redirecting to timeout.jsp after session timeout due to inactivity after 15 mins
          if (window.location.hostname.endsWith('.com') && window.name === 'SessionTimedOut') {
            window.name='';
            window.location.href = 'https://'+window.location.hostname + '/card/login/timeout.jsp';
          }
      }, []);

    useEffect(() => {
        document.title = intl.formatMessage({id: 'logon.ui.index.page.title'});
        if (mainRef.current) {
            mainRef.current.focus();
        }
        if (sessionExpired) {
            setErrorMessage(Constants.sessionTImeOutMessage);
            setHasError(true);
        }
    }, [sessionExpired]);

    // Add a resize event listener to detect screen size changes
    useEffect(() => {
    const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 960);
    };

    window.addEventListener("resize", handleResize);
    return () => {
        window.removeEventListener("resize", handleResize);
    };
    }, []);


    const showErrorOnPage = (error)=> {
        setErrorMessage(error);
        setHasError(true);
    }

    return(
        <main ref={mainRef} role="main" aria-label="Login Page" className="index-page-container" tabIndex="-1">
        <FlexLayout className={"two-col"} wrap={false}>
            <FlexItem className={"col1"} >
                <StackLayout className={"form-error-container"}>
                    <StatusDisplay
                        isSmallScreen={isSmallScreen}
                        hasError={hasError}
                        showRedirect={showRedirect}
                        isLoading={isLoading}
                        sessionExpired={sessionExpired}
                        errorMessage={errorMessage}
                        setHasError={setHasError}
                    />
                    <FlexItem>
                        <IndexPageFormComponent
                            closeAndClearModal={props.closeAndClearModal}
                            fillAndOpenModel={props.fillAndOpenModel}
                            showErrorOnPage={showErrorOnPage}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            setShowRedirect={setShowRedirect}
                        />
                    </FlexItem>
                </StackLayout>
            </FlexItem>
            <FlexItem className={"col2"}>
            <StackLayout>
                <FlexItem className="about-text">
                    <span className="text-heading">{Constants.homePageAboutHeading}</span><br/><br/>
                    <Text className="text-paragraph">
                        {Constants.homePageAboutTextLine1}<br/>
                        {Constants.homePageAboutTextLine2}<br/>
                        {Constants.homePageAboutTextLine3}<br/><br/>
                        {Constants.homePageAboutTextLine4}<br/>
                        {Constants.homePageAboutTextLine5}<br/>
                        {Constants.homePageAboutTextLine6}<br/>
                        {Constants.homePageAboutTextLine7}<br/>
                    </Text>
                    <br/>
                    <Link href="https://www.jpmorgan.com/payments/solutions/commercial-cards/program-management"
                          target="_blank">{Constants.homePageAboutLink}</Link>
                </FlexItem>
                <FlexItem className="bg-img" role="img" aria-label={intl.formatMessage({id: 'logon.ui.decorative.image.ada.label'})} >
                </FlexItem>
            </StackLayout>
            </FlexItem>
        </FlexLayout>
        </main>
    );
}
